import { useCallback, useState } from 'react';
import axios from 'axios';
import { SearchIcon } from 'lucide-react';
import ZipCodeInputMasked from '@/components/ZipCodeInputMasked';
import { Button } from '@/components/ui/button';
import { inputClassName } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import useClubErrors from '../hooks/useClubErrors';

export default function ClubAddressField({ value, onChange, onBlur, name, setValue }) {
    const { enqueueSnackbar } = useClubErrors();
    const [searching, setSearching] = useState(false);

    const searchPostalCode = useCallback(async () => {
        if (!value || value.length !== 8) return;

        try {
            setSearching(true);
            const { data } = await axios.get(`https://viacep.com.br/ws/${value}/json/`);

            if (data.erro) throw new Error('CEP não encontrado');

            setValue('street', data.logradouro || '');
            setValue('neighborhood', data.bairro || '');
            setValue('city', data.localidade || '');
            setValue('state', data.uf || '');
            setValue(
                'address',
                `${data.logradouro || ''}, ${data.bairro || ''}, ${data.localidade || ''}-${data.uf || ''}`,
            );
        } catch {
            setValue('street', '');
            setValue('neighborhood', '');
            setValue('city', '');
            setValue('state', '');
            setValue('address', '');
            enqueueSnackbar('CEP não encontrado. Preencha o endereço manualmente.', { variant: 'warning' });
        } finally {
            setSearching(false);
        }
    }, [enqueueSnackbar, setValue, value]);

    return (
        <div className="space-y-1">
            <div className="flex gap-2">
                <ZipCodeInputMasked
                    name={name}
                    value={value ?? ''}
                    onChange={onChange}
                    onBlur={event => {
                        onBlur?.(event);
                        searchPostalCode();
                    }}
                    className={cn(inputClassName, 'flex-1')}
                />
                <Button
                    type="button"
                    variant="outline"
                    size="icon-sm"
                    className="shrink-0"
                    onClick={searchPostalCode}
                    disabled={searching}
                    aria-label="Buscar CEP"
                >
                    <SearchIcon className="size-4" />
                </Button>
            </div>
        </div>
    );
}
